import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type EventItem = {
  id: string;
  attributes: any;
};

type FilteredEventsState = {
  count: number;
  events: Record<string, EventItem[]>;
  eventLoading: boolean;
};

const initialState: FilteredEventsState = {
  count: 0,
  events: {},
  eventLoading: false,
};

const filteredEventSlice = createSlice({
  name: "filteredEvent",
  initialState,
  reducers: {
    setFilteredEventCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    setFilteredEvents: (
      state,
      action: PayloadAction<{ key: string; events: EventItem[] }>,
    ) => {
      const { key, events } = action.payload;
      state.events[key] = events;
    },
    setFilteredEventsLoading: (state, action: PayloadAction<boolean>) => {
      state.eventLoading = action.payload;
    },
    clearFilteredEvents: () => initialState,
  },
});

export const {
  setFilteredEventCount,
  setFilteredEvents,
  setFilteredEventsLoading,
  clearFilteredEvents,
} = filteredEventSlice.actions;

export default filteredEventSlice.reducer;
